/* eslint-disable import/prefer-default-export */
import PropTypes from 'prop-types';

const AuthenticationTypeType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
});

export { AuthenticationTypeType };
